import { PlatformService } from './../../../services/platform';
import { StudiosService } from './../../../services/studios';
import { ClassesService } from './../../../services/classes';
import { FiltersService } from './../../../services/filters';
import { Component, trigger, state, style, transition, animate } from '@angular/core';
import { NavController, ModalController } from 'ionic-angular';
import { FiltersPage } from './filters/filters';
import { ClassPage } from '../shared/class/class';
import { StudioPage } from '../shared/studio/studio';
import { SearchBarPage } from './search-bar/search-bar';
import { SessionService } from '../../../services/session';
import { MapService } from '../../../services/map';
import { LocationsService } from '../../../services/locations';
import { MishiService } from '../../../services/mishi';

@Component({
  selector: 'page-find-class',
  templateUrl: 'find-class.html',
  animations: [
    trigger('panel', [
      state(
        'in',
        style({
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({
          transform: 'translateX(-100%)',
        }),
        animate(300),
      ]),
      transition('* => void', [
        animate(
          300,
          style({
            transform: 'translateX(100%)',
          })
        ),
      ]),
    ]),
  ],
})
export class FindClassPage {
  classPage = ClassPage;
  studioPage = StudioPage;
  currentDate = 0;
  showMap = false;
  gymInMap: any = null;
  hideMapForShowingOnStudio = false;
  studioChosen = false;
  hasStarted = false;
  classTypeFadeOut = false;

  studioInfo: any = {
    name: '',
    latitude: '',
    longitude: '',
    address: '',
    gym_pictures: [],
  };

  showMishiItem = true;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public classesService: ClassesService,
    public studiosService: StudiosService,
    public sessionService: SessionService,
    public platformService: PlatformService,
    public filtersService: FiltersService,
    public mishiService: MishiService,
    public mapService: MapService,
    public locationsService: LocationsService
  ) {}

  //Changes date when clicking in the date picker
  changeDate(event) {
    this.currentDate = event.date;
  }

  closeMishiItem() {
    this.showMishiItem = false;
  }

  // Opens Filters
  presentFiltersModal() {
    let modal = this.modalCtrl.create(FiltersPage);
    modal.onDidDismiss((data) => {
      if (data) {
        this.doRefresh();
      }
    });
    modal.present();
  }

  // Opens Search Bar
  presentSearchBarModal() {
    let modal = this.modalCtrl.create(SearchBarPage, { searchText: this.mapService.searchText });
    modal.onDidDismiss((gym) => {
      if (gym) {
        this.gymInMap = gym;
        this.mapService.searchText = gym.name;
        this.filtersService.queryParams.latitude = gym.latitude;
        this.filtersService.queryParams.longitude = gym.longitude;
        this.filtersService.queryParams.radius = '1';
        this.filtersService.queryParams.city = gym.city.id;
        this.filtersService.queryParams.services = [];
        this.filtersService.queryParams.zones = [];
        this.filtersService.queryParams.categories = [];
        this.doRefresh();
      }
    });
    modal.present();
  }

  //resets search filter
  cancelSearch() {
    this.removeStudio();
    this.mapService.searchText = '';
    this.mapService.lastSelectedMarker = null;
    this.filtersService.queryParams.latitude = null;
    this.filtersService.queryParams.longitude = null;
    this.filtersService.queryParams.radius = null;
    this.doRefresh();
  }

  //resets classType
  cancelClassType() {
    this.classTypeFadeOut = true;
    this.filtersService.queryParams.categories = [];
    this.filtersService.queryParams.services = [];
    this.doRefresh();
    //timeout must be ~= to animation time
    setTimeout(() => {
      this.classTypeFadeOut = false;
      this.filtersService.classType = '';
    }, 300);
  }

  //remove Studio
  removeStudio() {
    if (this.mapService.lastSelectedMarker && this.mapService.lastSelectedMarker.name === this.mapService.searchText) {
      this.gymInMap = null;
      this.studioChosen = false;
      if (!this.studioInfo.name) {
        this.studioInfo = 'x';
      }
      this.studioInfo = null;
    }
  }

  // Goes to a class in class list
  goToClass(classInfo) {
    if (classInfo.schedule.lesson_availability > classInfo.schedule.reservations) {
      this.navCtrl.push(this.classPage, { classInfo });
    }
  }

  // Displays studio banner in map
  displayStudio(event) {
    this.studioChosen = false;
    if (!event.studioInfo) {
      return;
    }
    setTimeout(() => {
      this.studioChosen = true;
    }, 1);
    this.studioInfo = event.studioInfo;
    this.gymInMap = event.studioInfo;
    this.mapService.searchText = event.studioInfo.name;
    this.filtersService.queryParams.latitude = event.studioInfo.latitude;
    this.filtersService.queryParams.longitude = event.studioInfo.longitude;
    this.filtersService.queryParams.radius = '1';
  }

  // Goes to a studio in map
  goToStudio() {
    // need to remove map in order to open map in new page
    this.hideMapForShowingOnStudio = true;
    // for some reason cant open studioPage with map if I dont set a timeout of >=1 ms
    setTimeout(() => {
      this.navCtrl.push(this.studioPage, { studioInfo: this.studioInfo });
    }, 1);
  }

  // Loads next 30 clases
  loadNext(infiniteScroll) {
    this.classesService
      .loadNext(
        this.currentDate,
        false,
        this.filtersService.queryParams.touched ? this.filtersService.queryParams.structure.lower : null,
        this.filtersService.queryParams.touched ? this.filtersService.queryParams.structure.upper : null,
        this.filtersService.queryParams.latitude,
        this.filtersService.queryParams.longitude,
        this.filtersService.queryParams.radius,
        this.filtersService.queryParams.services,
        this.filtersService.queryParams.gym,
        this.filtersService.queryParams.city,
        this.filtersService.queryParams.zones,
        this.filtersService.queryParams.categories
      )
      .then(() => {
        infiniteScroll.complete();
      })
      .catch((err) => {
        this.sessionService.reportError('findClassPage', 'loadNext()', err);
      });
  }

  // Restarts classes and loads first 30 classes
  doRefresh(refresher?) {
    this.classesService.initiateClasses();
    this.classesService.loadAll(
      true,
      this.filtersService.queryParams.touched ? this.filtersService.queryParams.structure.lower : null,
      this.filtersService.queryParams.touched ? this.filtersService.queryParams.structure.upper : null,
      this.filtersService.queryParams.latitude,
      this.filtersService.queryParams.longitude,
      this.filtersService.queryParams.radius,
      this.filtersService.queryParams.services,
      this.filtersService.queryParams.gym,
      this.filtersService.queryParams.city,
      this.filtersService.queryParams.zones,
      this.filtersService.queryParams.categories
    );
    if (refresher) {
      refresher.complete();
    }
  }

  //Hides map when leaving
  ionViewWillLeave() {
    this.hideMapForShowingOnStudio = true;
  }

  //Shows map when entering
  ionViewWillEnter() {
    this.hideMapForShowingOnStudio = false;
  }

  ionViewDidEnter() {
    this.hasStarted = true;
  }

  ionViewDidLoad() {
    window['page'] = 'FindClassPage'; // for GA
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/find-class/find-class.ts